import { storyblokEditable } from '@storyblok/react/rsc';
import { resolveAsset, optimizeImage, colorStyle } from '@/lib/helpers';

const Marquee = ({ blok }) => {
  // Defaults: black background, white text — overridden by editor picks.
  const style = colorStyle(blok, { into: { backgroundColor: '#251C29', color: '#FFFFFF' } });
  const fontSize = blok.font_size || 'text-20 sm:text-28 md:text-36';
  const text = blok.text || '';
  const iconSrc = resolveAsset(blok.icon);
  const speed = blok.speed || '20s';

  // Repeat content 4 times for seamless loop
  const items = Array.from({ length: 4 }, (_, i) => (
    <span key={i} className="flex items-center gap-8 shrink-0">
      <span className="whitespace-nowrap font-bold">{text}</span>
      {iconSrc && (
        <img
          src={optimizeImage(iconSrc, 50, 50)}
          alt=""
          width="50"
          height="50"
          className="h-[30px] md:h-[50px] w-auto"
          loading="lazy"
        />
      )}
    </span>
  ));

  return (
    <section
      {...storyblokEditable(blok)}
      className={`${fontSize} overflow-hidden py-4 sm:py-5`}
      style={style}
    >
      <div
        className="flex items-center gap-8 animate-marquee"
        aria-hidden="true"
        style={{ '--marquee-speed': speed }}
      >
        {items}
        {items}
      </div>
    </section>
  );
};

export default Marquee;
